__turbopack_context__.v({
  "bottomGradient": "Home-module__NNgVZa__bottomGradient",
  "container": "Home-module__NNgVZa__container",
  "content": "Home-module__NNgVZa__content",
  "content2": "Home-module__NNgVZa__content2",
  "contentWrapper": "Home-module__NNgVZa__contentWrapper",
  "joined": "Home-module__NNgVZa__joined",
  "scrollTarget": "Home-module__NNgVZa__scrollTarget",
  "statement": "Home-module__NNgVZa__statement",
  "supTitle": "Home-module__NNgVZa__supTitle",
  "text": "Home-module__NNgVZa__text",
  "title": "Home-module__NNgVZa__title",
  "titles": "Home-module__NNgVZa__titles",
  "topLeftGradient": "Home-module__NNgVZa__topLeftGradient",
  "topRightGradient": "Home-module__NNgVZa__topRightGradient",
});
